const en_US = {
  'my-annatel': 'My Account',
  'greeting': 'Hello',
  'farwell': 'Goodbye',
  'sign-in-to-manage-your-account': 'sign in to manage your account',
  'forgot-password': 'Forgot your password?',
  'remember-me': 'Remember me',
  'login': 'Login',
  'contact-information': 'contact information',
  'name': 'Name',
  'first-name': 'First Name',
  'last-name': 'Last Name',
  'birth-date': 'Birth date',
  'phone': 'Phone',
  'other-phone': 'Other phone',
  'address': 'Address',
  'bank-details': 'Bank details',
  'number': 'Number',
  'expiration-date': 'Expiration Date',
  'card-holder': 'Card holder',
  'Actions': 'Actions',
  'change-profile-information': 'Change my personal information',
  'change-password': 'Change password',
  'new-password': 'New password',
  'change-payment': 'Change my payment method',
  'password': 'Password',
  'current-password': 'Current password',
  'password-confirmation': 'Password confirmation',
  'enter-current-password': 'Enter your current password',
  'enter-new-password': 'Enter your new password (min. 6 chars)',
  'confirm-new-password': 'Confirm your new password (min. 6 chars)',
  'my-personal-information': 'My personal information',
  'enter-full-address': 'Enter your full address and choose from the list that appears. If it does not appear, please click',
  'house-number': 'House number',
  'apartment-number': 'Apartment number',
  'entrance': 'Entrance',
  'city': 'City',
  'country': 'Country',
  'postcode': 'ZIP code',
  'street-name': 'Street Name',
  'total': 'Total',
  'includes VAT': 'w/ VAT',
  'personal-information': 'Personal information',
  'contact-details': 'Contact details',
  'address-not-found-message': 'Enter your full address and choose from the list that appears. If it does not appear, please click ',
  'right-here': 'right here',
  'cancel': 'Cancel',
  'save': 'Save',
  'no-changes-to-save': 'No changes to save',
  'contact-details-have-been-saved': 'Contact details have been saved',
  'my-services': 'My services',
  'mobile': 'Mobile',
  'land-line': 'Landline',
  'management-of-my-subscription': 'Management of my subscription',
  'provider': 'Provider',
  'sim-number': 'SIM number',
  'esim-number': 'eSIM number',
  'esim-deleted': 'DELETED',
  'active-esim': 'eSim',
  'help-esim': 'Information status eSim',
  'info-esim-on-p1': 'Your e-sim is turned on.',
  'info-esim-off-p1': 'iPhone: Your e-sim is currently turned off.To turn it back on please go to settings - cellular- under sims- click on the annatel e-sim and turn on this line.',
  'info-esim-off-p2': 'Android: Your e-sim is currently turned off. To turn it on please go to the sim card manager in connections/mobile networks (exact terms may differ) click on the annatel sim and turn it on. ',
  'info-esim-off-p3': ' ',
  'info-esim-off-p4': ' ',
  'info-esim-off-p5': ' ',
  'info-esim-deleted-p1': 'You have deleted your e-sim. You have received a new e-sim via email.',
  'info-esim-deleted-p2': 'If you have not received it please reach out to us via WhatsApp',
  'info-esim-deleted-p3': ' ',
  'info-esim-deleted-p4': ' ',
  'link-whatapp-deleted': 'https://wa.me/972555006565',
  'activation-date': 'Activation date',
  'other-information': 'Other information',
  'active': 'Active',
  'inactive': 'Inactive',
  'virtual-number': 'Virtual number',
  'secondary-numbers': 'Secondary number(s)',
  'current-offer': 'Current plan',
  'more-information': 'More information',
  'close-information': 'Close',
  'freeze-request': 'Freeze request',
  'unfreeze-request': 'Unfreeze request',
  'search-line': 'Search a line',
  'Cancel-freeze-message': 'Cancel the current freeze',
  'sure-un-freeze-message': 'Are you sure you want to un freeze the product',
  'freeze-request-info-message': 'Freeze will be charged 20 shekels per month (not prorated). Freeze is not compatible with Mispari. Any active Mispari will be automatically terminated on the Freeze starting date. A Freeze can only be set up from your next billing date. The minimum duration of a Freeze is one full month.',
  'freeze-request-tv-info-message': 'A Freeze can only be set up from your next billing date',
  'important-information': 'Important information',
  'freeze-selecte-date-last': 'Ending date',
  'freeze-selecte-date-first': 'Starting date',
  'optional': 'If known, optional',
  'confirmation-freeze-message': 'Are you sure you want to freeze the product on selected dates ?',
  'call-date': 'Call date',
  'call-time': 'Call time',
  'called-number': 'Called number',
  'calling-number': 'Calling number',
  'call-duration': 'Call duration',
  'call-price-excluding-tax': 'Call price tax excl.',
  'from': 'From',
  'to': 'To',
  'call-details': 'Call details',
  'manage-my-voicemail': 'Manage my voicemail',
  'sending-voice-messages-to-answering-machine': 'Sending your voice messages to your answering machine',

  'your-answering-machine': 'Your answering machine',
  'not-receive-voice-messages-alert': 'If you choose not to send your voicemail messages to your mailbox, you will not receive alerts. You will need to dial * 151 or 0747146543 from your Annatel mobile to listen to your voice messages.',
  'sign-out': 'Sign out',
  'balance': 'My usage',
  'consumption': 'Call details',
  'voiceMail': 'Voicemail',
  'roaming': 'Roaming Top-up',
  'data': 'Internet Top-up',
  'data-prepaid': 'Prepaid Top-up',
  'faxReceived': 'Fax receive',
  'faxDownload': 'Download fax',
  'infiniteMobile': 'Infinite Mobile',
  'createFreeze': 'Freeze',
  'mispariActivate': 'Activate mispari',
  'payment-type': 'Payment type',
  'user-level': 'User level',
  'serial-number': 'Serial number',
  'installation-address': 'Installation address',
  'device': 'Device',
  'mac_address': 'Mac Address',
  'callForward': 'Call forward',
  'displayNumber': 'Display number',
  'page-not-available': 'Sorry, this page is not yet available',
  'insert-email': 'Insert your email',
  'email-address-receiving-your-voice-messages': 'Email address for receiving your voice messages',
  'your-email-has-changed': 'Changes applied',
  'mispari-in-service-since': 'Mispari is currently in service on this line since',
  'mispariDesactivate': 'Deactivate mispari',
  'no-results': 'No results',
  'confirm': 'Confirm',
  'confirmation-message': 'For security reasons, please confirm your request:',
  'profile': 'Profile',
  'invoices': 'Invoices',
  'invoice-status': 'Status',
  'pay-bill': 'Pay the bill',
  'pay-all-invoices': 'Pay all invoices',
  'invoice-number': 'Invoice Number',
  'go-back-to-the-Annatel-website': 'To the Annatel website',
  'authValidation-message': 'The Login or password is incorrect',
  'freeze-the-line': 'You requested to freeze the line',
  'download': 'Download',
  'details': 'Details',
  'mispari': 'Mispari',
  'see-existing-freeze': 'Change existing freeze',
  'information-product-frozen': 'Your line is or will be on freeze starting from',
  'are-you-sure-unblock': 'To unfreeze the line or cancel the requested freeze, please click the Unfreeze button',
  'select-date': 'Select a date',
  'Select-date-time-activate-Mispari': 'Select the date and time to activate Mispari',
  'mispari-selecte-date-first': 'Starting date of the mispari',
  'mispari-selecte-date-last': 'Ending date of the mispari',
  'no-active-mispari': 'There is no active mispari in the account',
  'change-date-time-activate-Mispari': 'If you want to change this please select the changes you want to make',
  'which-number-forward-calls': 'Number to which you want your calls to be forwarded',
  'choose-start-date-time-mispari': 'Starting date',
  'choose-end-date-time-mispari': 'Ending date',
  'active-mispari-message': 'Configure your Mispari below :',
  'end': 'End',
  'choose-date-time-of': 'Ending date',
  'of-your-mispari': 'of your Mispari',
  'now': 'now',
  'cancel-the-Mispari': 'cancel the Mispari',
  'do-you-want-cancel-Mispari': 'Do you want to cancel the Mispari',
  'do-not-change': 'Do not change',
  'change-active-mispari-message': 'There is an active Mispari on your line. You can change the ending date below.',
  'update-mispari-message': 'Change your Mispari settings',
  'mispari-canceled': 'Mispari have been Canceled',
  'change-payment-message': 'Are you sure you want to change your payment card',
  'invalid-Credit-Card': 'Invalid Credit-Card',
  'add-payment-method-title': 'Add a new payment method',
  'missing-field': 'Missing Field',
  'Change-language-button': 'Changer en français',
  'fax': 'Fax',
  'next-billing-date': 'Next billing date',
  'freeze-request-subtitle': 'Configure your freeze below',
  'un-freeze-button': 'Unfreeze',
  'is-in-bundle': 'Part of a bundle',
  'no-options-message': 'For any question, please contact us at *0555',
  'inactives': 'Inactives',
  'no-service-header': 'You have no services in this category',
  'no-service-message': 'To subscribe to new services, contact your customer service at * 0555 from Israel or by email at support@annatel.net',
  'received': 'Incoming',
  'outgoing-calls': 'Outgoing',
  'missed': 'Missed',
  'tv-tv': 'TV',
  'without-stopping': 'Without ending date',
  'no-voice-mail': '(No voicemail)',
  'destination': 'Destination',
  'date': 'Date',
  'confirmation-message-title': 'Confirmation',
  'unfreeze-the-line-confirmation-message': 'If you want to unfreeze the line, you can click below.',
  'freeze': 'Freeze',
  'internet': 'Internet',
  'bundles': 'Bundles',
  'contact': 'Contact',
  'mispari-start-now': 'Now',
  'mispari-no-end-date': 'No end date',
  'important-information-message-active-mispari': 'Mispari will be charged 20 shekels per 30-day period (not prorated). Mispari is not compatible with Freeze. Any active Mispari will be automatically terminated on the Freeze starting date (or will not be activated).',
  'successfully-connected-message': 'Connected',
  'call-details-subtitle': 'Call details',
  'start-date': 'Starting date',
  'end-date': 'Ending date',
  'date-not-available': 'Not available',
  'changes-saved-successfully': 'Changes successfully applied',
  'changes-failed': 'Changes failed to be applied',
  'un-freeze-the-line': 'Unfreeze the line',
  'call-details-go-button': 'Go',
  'lignes-inactives': 'Inactive lines',
  'confirmation-update-mispari-message': 'Change your mispari settings',
  'confirmation-change-active-mispari-message': 'Change your Mispari settings',
  'confirmation-active-mispari-message': 'Activate Mispari',
  'login-button': 'Login',
  'start-now-option': 'Now',
  'no-end-date-option': 'No end date',
  'current-mispari-number': 'Current forward :',
  'teudat-zeut': 'Teudat Zeut',
  'must-be-a-number': 'Must be a number',
  'update-freeze-subtitle': 'Manage your ongoing or upcoming freeze below: ',
  'do-you-want-cancel-freeze': 'Click to cancel the freeze',
  'cancel-the-freeze-button': 'Cancel freeze',
  'do-you-want-cancel-freeze-confirmation-message': 'You want to cancel the upcoming freeze of your line',
  'on-phone-number': 'on phone number',
  'change-existing-mispari': 'Change Mispari',
  'start-mispari': 'Start Mispari',
  'mispari-option-when-line-is-frozen': 'Start Mispari (unavailable on freeze)',
  'change-profile-address-information': 'Change my address',
  'change-address-title': 'Address',
  'enter-adress-placeholder': 'Please enter your address',
  'password-not-match-confirm-password': 'Passwords do not match',
  'password-length-error': 'Your password must be at least 6 characters long',
  'password-changed-successfully': 'Password changed successfully',
  'update-ongoing-freeze': 'You want to update the ongoing freeze of your line',
  'cancel-ongoing-freeze': 'You want to unfreeze your line now',
  'update-upcoming-freeze': 'You want to update the upcoming freeze of your line',
  'pay-now-button': 'Pay now',
  'pay-now-confirm-message': 'You are about to pay the following invoice(s)',
  'invoice-id': 'Invoice',
  'failed-attempt-payment': 'Failed to attempt payment',
  'pending-activation': 'Pending activation',
  'upgrade-to': ' to ',
  'activeMobileItems': 'Actives',
  'activate-my-line': 'Activate my line',
  'awaiting-migration': 'Awaiting migration',
  'activation-in-progress': 'Activation in progress',
  'upgrade-update-on': 'Upgrade planned on ',
  'apn-filter': 'Internet filter',
  'activate-apn-filter': 'Activate the internet filter?',
  'warning-apn-title': 'Important information: ',
  'warning-apn-text': ' In order for the filter status to change, please reboot your device 5 minutes after validating this page.',

  // Used for call details description
  'call_in': 'Call in',
  'sms_in': 'SMS in',
  'call_roaming': 'Call roaming',
  '_to_': ' to ',

  'has-future-freeze': 'Freeze planned',
  'end-of-freeze-planned-on': 'End of freeze planned on',
  'has-active-mispari': 'Active mispari',
  'mispari-ends-on': ' until',
  'mispari-planned': 'Mispari planned ',
  'mispari-forward-to': ' to ',
  'mispari-without-end-planned-on': ' from ',
  'mispari-with-end-planned-on': ' to ',
  'mispari-planned-until': ' until ',
  'end-of-current-mispari-planned-on': 'Current mispari ends on ',
  'login-or-password-incorrect': 'Login or password incorrect'
};
export default en_US;



// WEBPACK FOOTER //
// ./src/localeAssets/en.js